export default __webpack_public_path__ + "static/media/pencil.d3ff5650.png";